import { useEffect } from 'react';
import { Link, useParams } from 'react-router';
import { ChevronRightIcon } from '@radix-ui/react-icons';
import { observer } from 'mobx-react-lite';

import { Header } from './project.page';
import { uiStore } from '../../core/stores/ui-store';
import { Task } from '../../app/entities';
import { TaskDetail } from '../../features/tasks/components/task-detail';

import styles from './project-task.route.module.scss';
export const ProjectTaskRoute = observer(() => {
  const { taskId } = useParams();
  const task = Task.getOne(taskId) as Task;

  useEffect(() => {
    uiStore.currentLocation = 'project.tasks';

    return () => {
      uiStore.currentLocation = '';
    };
  }, []);

  if (!task) {
    return;
  }

  return (
    <>
      <Header>
        <div className={styles['crumb']}>
          <Link className={styles['parent']} to="../">
            Tasks
          </Link>
          <ChevronRightIcon />
          {task.title}
        </div>
      </Header>

      <div className={styles['scroller']}>
        <TaskDetail task={task} />
      </div>
    </>
  );
});
